// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';


	var WebFont = require('webfontloader');

	WebFont.load({
		google: {
			families: ['Anton', 'Poppins']
		}
	});
} )();